import React from "react";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { useStaticQuery, graphql} from "gatsby";

//Utils
import { isMobile } from "../../../utils/helpers";

// Styles //
import "./featuresToMeetBox.scss";

interface FeaturesToMeetBoxProps {
    canApply: boolean;
    featureList: any;
    title: string;
    showIndex: boolean;
    setShowList: Function;
    index: number;
}

const FeaturesToMeetBox = (props: FeaturesToMeetBoxProps) => {
    const {
        canApply,
        featureList,
        title,
        showIndex,
        setShowList,
        index
    } = props;
    
    const icons = useStaticQuery(graphql`
        query featureListIcons {
            iconCheckForFeatures: contentfulAsset(
            contentful_id: {eq: "1bzZg310a1xozbJtjQppdu"}) 
            {
                description
                file {
                    url
                }
            }
            iconXForFeatures: contentfulAsset(
            contentful_id: {eq: "7MsA4pVK4BbYRxtDdFYB6z"}) 
            {
                description
                file {
                    url
                }
            }
            iconCheckForList: contentfulAsset(
            contentful_id: {eq: "6qb6CZUbTwNuEPe3c8QCrj"})
            {
                description
                file {
                    url
                }
            }
            iconXForList: contentfulAsset(
            contentful_id: {eq: "4ERML8XUodxGJXn91KRQwB"}) 
            {
                description
                file {
                    url
                }
            }
            iconPlus: contentfulAsset(
                contentful_id: {eq: "3MexezKA7wPngyd07HhZFu"}) 
            {
                    description
                    file {
                        url
                    }
            }
            iconMinus: contentfulAsset(
                contentful_id: {eq: "7AF6mBCoxv60o1qgiKzF1E"}) 
            {
                description
                file {
                    url
                }
            }
        }
    `);

    const iconFeatures = canApply? icons.iconCheckForFeatures 
                        : icons.iconXForFeatures;
    const iconForList = canApply? icons.iconCheckForList
                        : icons.iconXForList;
    const iconPlus = icons.iconPlus;
    const iconMinus = icons.iconMinus;

    const toggleList = () => {
        if(showIndex){
            setShowList(999);
        }else{
            setShowList(index);
        }
    };

    return (
        <div className="m-features-to-meet-box">
            <div className="m-features-to-meet-box__top">
                <div className="m-features-to-meet-box__top__image">
                    <img src={iconFeatures.file.url} alt={iconFeatures.description}/>
                </div>
                <div className="m-features-to-meet-box__top__title">
                    <h3>{title}</h3>
                </div>
                {isMobile() &&
                    <div className="m-features-to-meet-box__top__mobileIcon" onClick={toggleList}>
                        {showIndex ? <img src={iconMinus.file.url} alt={iconMinus.description}/> 
                            : <img src={iconPlus.file.url} alt={iconPlus.description}/>
                        }
                    </div>
                }                
            </div>
            <div className={`m-features-to-meet-box__list ${isMobile() ? 
                                `m-features-to-meet-box__list--mobile ${showIndex ? "show" : "" }` 
                                : ""}`
                            }>
                {featureList?.map(item => 
                    <div className="m-features-to-meet-box__list__description">
                        <img src={iconForList.file.url} alt={iconForList.description}/>
                        {documentToReactComponents(
                            item.descripcion.json
                        )}
                    </div> 
                )}
            </div>
        </div>
    );
};

export default FeaturesToMeetBox;
